import { Link } from "react-router-dom";

interface BreadcrumbsProps {
  items: { label: string; to?: string }[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-600">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-400">
              <i className="ri-arrow-right-s-line text-sm" />
            </span>
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}